import z from 'zod';

export const flowRunBlockMetricSchema = z.object({
  id: z.string(),
  created: z.string().datetime(),
  updated: z.string().datetime(),
  organizationId: z.string(),
  flowRunBlockId: z.string(),
  blockId: z.string().nullable(),
  flowRunId: z.string(),
  metricName: z.string(),
  metricValue: z.number(),
  metadata: z.record(z.string(), z.string()).optional().nullable(),
  flowRunStartTime: z.string().datetime(),
  blockType: z.string(),
  practiceId: z.string().nullable(),
  entityId: z.string().nullable(),
  entityType: z.string().nullable(),
  flowDefinitionId: z.string(),
  agentId: z.string().nullable(),
  flowId: z.string().nullable(),
  snapshotId: z.string().nullable(),
});

export type FlowRunBlockMetric = z.infer<typeof flowRunBlockMetricSchema>;

export enum MetricTypeFilter {
  /** Only return billable metrics, as defined by the m3ter rate card applicable to the organization */
  Billable = 'Billable',
}

export const findAllParamsSchema = z.object({
  flowRunId: z.string(),
  metricTypeFilter: z.enum(MetricTypeFilter).optional(),
});

export type FlowRunBlockMetricFindAllParams = z.infer<typeof findAllParamsSchema>;
